<template>
    <div>
        <template>
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> Whitelist Companies ({{active_count}})</h1>
                <div class="searching float-right mr-2">
                    <input id="search_active" type="text" placeholder="Search" class="form-control search" name="" />
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
				<div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
					<table id="companyTable" class="table">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Company Name</th>
                                <th>User Name</th>
                                <th>Phone</th>
                                <th>Email</th>
                                <th>Address</th>
                            </tr>
                        </thead>
                    </table>
				</div>
			</div>
        </template>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                dtActive : null,
                active_count : 0,
            };
        },
        mounted() {
            gThat = this;
            this.activeCompanies();
        },
        methods: {
            activeCompanies(){
                this.dtActive = $('#companyTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/WhitelistCompanies",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": 'records',
                        "data": function ( d ) {
                            d.tab = 'active';
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'company_name'},
                        {data: 'user_name'},
                        {data: 'user_cnic'},
                        {data: 'email'},
                        {data: 'mobile_no'},

                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 4 ]
                    }],
                    "initComplete": (settings, json) => { this.active_count = json.recordsTotal; this.$Progress.finish();}
                });
                $('#search_active').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        gThat.dtActive.search(this.value).draw();
                    }
                });
            },

        },
    }
</script>
